import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

export interface BannerProps extends PropsWithChildren {
    shown: boolean;
}
export const Banner = (props: BannerProps) => {
    return (
        <div
            css={[
                bannerCss,
                props.shown &&
                    css({
                        background: wacToken("color.primary.black"),
                        borderRadius: "inherit"
                    })
            ]}
        >
            {props.shown && <div css={bannerContent}>{props.children}</div>}
        </div>
    );
};

const bannerCss = css({
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
});

const bannerContent = css({
    color: wacToken("color.neutral.light0"),
    fontSize: "12px",
    fontFamily: "Charlie Text",
    fontWeight: "600",
    textTransform: "uppercase",
    lineHeight: "18px",
    letterSpacing: 1,
    wordWrap: "break-word",
    textAlign: "center"
});
